<template>
  <b-col class="m-auto">
    <slot name="logo"></slot>
    <h4 class="text-muted pb-4" v-if="!loading">
      {{ labels.recoverTitle }}
    </h4>

    <div v-if="loading" class="loading">
      <loading />
      <p>{{ labels.confirmEmailPage.loading }}</p>
    </div>

    <b-form v-else @submit.prevent="login">
      <b-form-group>
        <b-form-select
          id="secret-question-form-select"
          class="secret-question-select"
          size="lg"
          required
          @input="changeSecretQuestion($event)"
        >
          <option
            v-for="question in secretQuestions"
            :key="question.id"
            :value="question.id"
          >
            {{ question.label }}
          </option>
        </b-form-select>
        <label for="secret-question-form-select" class="custom-input-label">
          {{ labels.secretQuestion }}
        </label>

        <label class="mdi mdi-chevron-down select-icon"></label>
      </b-form-group>

      <CustomInput
        name="secret-question-answer"
        type="text"
        class="secret-question-answer"
        :label="labels.secretQuestionAnswer"
        @update="form.secretQuestionAnswer = $event.value"
      />

      <b-row role="alert" v-if="message" align-h="center">
        <span class="text-secondary error-message">{{ message }}</span>
      </b-row>

      <b-button
        id="btn-send"
        @keyup.enter.prevent="submit"
        variant="quartenary"
        :disabled="submitInProgress"
        type="submit"
        class="col-12 mt-3 text-white"
      >
        <i
          class="mdi mdi-spin pr-2"
          :class="{ 'mdi-loading': submitInProgress }"
        ></i
        >{{ labels.send }}
      </b-button>
    </b-form>

    <b-row align-h="center" class="mt-3 mb-3" v-if="!loading">
      <b-col>
        <b-link id="backToLogin" :to="{ name: 'login.auth' }">
          {{ labels.returnToLogin }}
        </b-link>
      </b-col>
    </b-row>
  </b-col>
</template>

<script>
import { mapGetters } from 'vuex'
import CustomInput from '@/components/Shared/Form/CustomInput.vue'
import { sendPassword } from '@/service/account'
import Loading from '@/components/Shared/Loading.vue'

export default {
  components: {
    CustomInput,
    Loading,
  },

  mounted() {
    this.$root.$emit('setPageTitle', { context: this, path: 'resetPassword' })

    this.$nextTick(() => {
      this.loading = true
      this.$store
        .dispatch('user/loadSecretQuestions')
        .then(async ({ data }) => {
          this.secretQuestions = data
        })
        .catch(error => {
          this.$store.commit('updateMessage', error.response.data.message)
        })
        .finally(() => {
          this.loading = false
        })
    })
  },

  data: function() {
    return {
      loading: false,
      secretQuestions: undefined,
      submitInProgress: false,
      message: null,
      form: {
        login: this.$route.query.login,
        secretQuestion: null,
        secretQuestionAnswer: null,
      },
    }
  },
  computed: {
    ...mapGetters(['resources']),

    labels: function() {
      return Object.assign(
        {},
        this.resources.page.login.password,
        this.resources.general.input,
        this.resources.general.buttons,
        this.resources.page.login.new,
        this.resources.page.login.confirmAccount
      )
    },
  },
  methods: {
    changeSecretQuestion(value) {
      this.form.secretQuestion = value
    },

    async login() {
      if (this.submitInProgress) return false

      this.submitInProgress = true
      this.message = null

      try {
        const response = await sendPassword(
          this.form.login,
          this.form.secretQuestion,
          this.form.secretQuestionAnswer
        )
        const { token = false } = response

        return this.$router.push({
          name: 'login.password.reset',
          params: { token },
          query: { email: this.form.login },
        })
      } catch (error) {
        this.message = error.message
      }
      this.submitInProgress = false
    },
  },
}
</script>

<style scoped lang="scss">
.loading {
  margin: 0 auto;
  text-align: center;
}

.secret-question-select {
  cursor: pointer;
}

.secret-question-answer {
  padding-top: 1.2rem !important;
}

/deep/ .custom-input-label {
  font-size: 12px;
  top: -18px;
}

.select-icon {
  top: 2px !important;
  right: 6px !important;
}
</style>
